import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../user_and_auth/auth.service';
import { UserService } from '../user_and_auth/user.service';

/**
 * Gates an admin-only route. Refreshes the JWT first (same as `authGuard`),
 * then checks the `is_admin` flag set from `/profiles/self`. Falls through to
 * /login if not authenticated, or to / if authenticated but not admin — we
 * deliberately don't surface a "you are not an admin" message because the
 * server is the source of truth and will 403 admin endpoints regardless.
 */
export const adminGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const userSvc = inject(UserService);
  const router = inject(Router);

  const ok = await auth.ensureValidJwt();
  if (!ok) return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });

  if (userSvc.user()?.is_admin) return true;
  return router.createUrlTree(['/']);
};
